<app-card>
  <div class="container mt-n2 ml-n2" text>
    <div class="ml-3">
      <div class="row">
        <div class="col-1" style="max-width: 40px"></div>
        <div class="d-flex flex-column ml-3">
          <bdg-label type="subheading-1">{{ residente?.nome | infoLabel }}</bdg-label>
          <bdg-label *ngIf="isResidenciaMulti() && residente?.categoriaProfissional" type="subheading-2">{{
            residente?.categoriaProfissional?.descricao | infoLabel
          }}</bdg-label>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-1 pl-0" [style]="textAvatarDivStyle">
          <bdg-text-avatar labelType="subheading-1" [text]="residente?.nome"></bdg-text-avatar>
        </div>
        <div class="col-2">
          <bdg-info-label label="CPF" direction="horizontal">{{ residente?.cpf | cpf | infoLabel }} </bdg-info-label>
        </div>
        <div class="col-3">
          <bdg-info-label label="E-mail" direction="horizontal">{{ residente?.email | infoLabel }}</bdg-info-label>
        </div>
        <div class="col-3">
          <bdg-info-label label="Telefone" direction="horizontal">
            {{ residente?.telefone | telefone | infoLabel }}
          </bdg-info-label>
        </div>
        <div class="col-3">
          <bdg-info-label label="Cadastrado em" direction="horizontal">
            {{ residente?.dataCadastro | date: 'dd/MM/yy' | infoLabel }}
          </bdg-info-label>
        </div>
      </div>
    </div>
  </div>

  <div chips class="mb-n2" style="margin-left: 3.6rem">
    <bdg-tag accent="gray" *ngIf="canShowAnoResidencia() && residente?.anoResidencia">
      {{ residente?.anoResidencia?.descricao }}
    </bdg-tag>
    <bdg-tag *ngIf="residente?.situacaoMatricula" [accent]="getSituacaoResidenteAccent(residente?.situacaoMatricula)">
      {{ residente?.situacaoMatricula?.descricao }}
    </bdg-tag>
  </div>
  <div buttons class="mb-n2">
    <bdg-button label="CANCELAR MATRÍCULA" *ngIf="canShowCancelar()" (click)="onCancelarClicked()"></bdg-button>
    <bdg-button
      *ngIf="showVisualizarResidente"
      class="ml-2"
      label="VISUALIZAR"
      (click)="onVisualizarClicked()"
    ></bdg-button>
  </div>
</app-card>
